<template>
  <a-modal
    title="添加产品"
    width="70%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="submitAdd"
    @cancel="visible = false"
  >
    <div class="table-page-search-wrapper">
      <a-form
        class="ant-advanced-search-form"
        :form="form"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        @submit="handleSearch"
      >
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="产品名称">
              <a-input
                placeholder="请输入产品名称"
                v-model="fundName"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :lg="7" :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="handleReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table">
      <a-table
        bordered
        :columns="columns"
        :data-source="prouuctArr"
        rowKey="fundCode"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        @change="handleTableChange"
      >
        <!-- <span slot="fundIcon" slot-scope="text">
            <img :src="text" />
          </span> -->
        <span slot="action" slot-scope="text, record">
          <a @click="handleConfigure(record.fundCode)">配置可见内容</a>

          <a-divider type="vertical" />
          <a @click="handleGroup(record.fundCode)">分组</a>
        </span>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import {
  getNotGroupProductList,
  addProductToAppointProductGroup
} from '@/api/product';

const columns = [
  {
    title: '#',
    align: 'center',
    dataIndex: 'index'
  },
  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode'
  },
  {
    title: '产品名称',
    align: 'center',
    dataIndex: 'fundName',
    scopedSlots: { customRender: 'fundName' }
  },
  {
    title: '投资类型',
    align: 'center',
    dataIndex: 'investTypeName'
  }
  // {
  //   title: '产品性质',
  //   align: 'center',
  //   dataIndex: 'fundIcon',
  //   key: 'fundIcon',
  //   scopedSlots: {
  //     customRender: 'fundIcon'
  //   }
  // },
  // {
  //   title: '产品投资类型',
  //   align: 'center',
  //   dataIndex: 'fundIcon',
  //   key: 'fundIcon',
  //   scopedSlots: {
  //     customRender: 'fundIcon'
  //   }
  // }
];
export default {
  data() {
    return {
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      columns,
      form: this.$form.createForm(this),
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      prouuctArr: [],
      selectedRowKeys: [],
      visible: false,
      investType: '',
      fundName: '',
      confirmLoading: false,
      fundGroupId: ''
    };
  },

  created() {
    this.initProductList();
  },
  methods: {
    handleAddVisible(id) {
      this.visible = true;
      this.fundGroupId = id;
    },

    //搜索
    handleSearch(e) {
      e.preventDefault();
      this.initProductList(1);
    },

    //重置
    handleReset() {
      this.fundName = '';
      this.initProductList(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    //table数据
    initProductList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = `?investType=${this.investType}&pageNo=${this.ipagination.current}&pageSize=${this.ipagination.pageSize}&fundName=${this.fundName}`;
      that.loading = true;
      getNotGroupProductList(params).then(res => {
        that.loading = false;
        if (res.success) {
          that.prouuctArr =
            res.result && res.result.list ? res.result.list : [];
          that.prouuctArr.map((item, index) => {
            item.index = index + 1;
          });
          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },
    //将产品添加到指定分组
    submitAdd() {
      let fundCodeList = [];
      if (this.selectedRows.length == 0) {
        this.$message.warn('请至少选择一个产品');
        return;
      } else {
        this.selectedRows.map(item => {
          fundCodeList.push(item.fundCode);
        });
      }
      let params = {
        fundGroupId: this.fundGroupId,
        fundCodeList
      };
      addProductToAppointProductGroup(params).then(res => {
        if (res.success) {
          this.visible = false;
          this.$message.success('操作成功');
          this.$emit('initProductList', '1');
          this.onClearSelected();
          this.initProductList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(this.selectedRows);
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initProductList();
    }
  }
};
</script>
<style scoped>
.table-operator {
  margin-bottom: 10px;
}
.table-operator .ant-btn {
  margin-right: 10px;
}
</style>
